import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const StumpGrindingRootRemovalPage = lazy(() => import('../pages/stump-grinding-root-removal/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/stump-grinding-root-removal',
    element: <StumpGrindingRootRemovalPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
